import { Hit } from 'react-instantsearch-core'
import { Configure, InstantSearch } from 'react-instantsearch-dom'
import { AlgoliaIndex } from 'search'
import AlgoliaClient from 'search/components/AlgoliaSearchClient'
import ProductHits, { Hits } from 'search/components/ProductHits'
import { SearchHit } from 'search/utils/mapHitsToProducts'

type TrendingProductsProps = {
  hidePrices: boolean
  hits?: Hit<SearchHit>[]
  isAlgolia?: boolean
}

export const TrendingProducts = ({ hidePrices, hits, isAlgolia }: TrendingProductsProps) => {
  if (isAlgolia === false && hits) {
    return <Hits hidePrices={hidePrices} hits={hits} isAlgolia={false} />
  }
  return (
    <InstantSearch indexName={AlgoliaIndex.Trending} searchClient={AlgoliaClient}>
      <Configure hitsPerPage={8} distinct />
      <ProductHits hidePrices={hidePrices} />
    </InstantSearch>
  )
}

export default TrendingProducts
